<span {...$$props} on:click>
  <slot />
</span>
